import { AgingBucket, IAgingBucketData } from 'src/types';

/**
 * The four buckets the open total requires, named explicitly rather than read via
 * `Object.values` — a response missing a whole key (e.g. no `60_plus` at all, not just a zero
 * one) would otherwise sum the three that DID arrive into an understated total with nothing to
 * say it was partial.
 */
export const AGING_BUCKET_KEYS: readonly AgingBucket[] = ['current', '1_30', '31_60', '60_plus'];

/**
 * The total across the named buckets, or null when any of them is absent or its amount is
 * missing or not finite. Defaulting a missing bucket or amount to €0 would understate the figure
 * rather than admit it cannot be computed — the card renders "—", not a number built on a guess.
 *
 * NAT-2519 wrote this inside the cash-cycle section; NAT-2545 moved it here so «Situazione
 * attuale» reads the open and overdue receivables by the same rule as the net position.
 */
export const sumBuckets = (
  buckets?: Partial<Record<AgingBucket, IAgingBucketData>>,
  keys: readonly AgingBucket[] = AGING_BUCKET_KEYS,
): number | null => {
  if (!buckets) return null;
  const amounts = keys.map((key) => buckets[key]?.amount);
  if (amounts.some((amount) => !Number.isFinite(amount))) return null;
  return amounts.reduce<number>((total, amount) => total + (amount as number), 0);
};
